module.exports = __webpack_public_path__ + "static/page-8-fc9061a191a0fb4294214540f1ea0031.jpg";